import React, { useState, useCallback } from 'react';
import moment from 'moment-timezone';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Button, Badge } from 'react-bootstrap';
import { updateLiveDataShow } from '../../actions/socket';
import { SubNav } from '../layout/submenu';
import { searchWord } from '../../helpers/common';
import LogModal from './LogModal';
import { DISPLAY_DATETIMESECONDS_FORMAT2, TOPIC_SENSOR, TOPIC_QLOST } from '../../constants';
import "../../../assets/scss/live-console.scss";

const LiveConsoleWindow = (props) => {    
    const dispatch = useDispatch();
    const messageList = useSelector((state => state.socket.messageList.sort((a, b) => b.ts - a.ts)));
    const timezoneIdentifier = useSelector((state => state.farm.currentFarm.timezone_identifier));
    const egList = useSelector((state => state.map.filteredEgList));

    const [showModal, setShowModal] = useState(false);
    const [logInfo, setLogInfo] = useState(null);
    const [searchText, setSearchText] = useState("");
    const egIds = egList.map(e => e.egId);
    const deviceIds = egList.map(e => e.deviceId);

    const handleModal = item => {
        setShowModal(true);
        setLogInfo(item);
    };

    const onClose = () => {
        setShowModal(false);
        setLogInfo(null);
    };

    const getTopic = useCallback((item) => {
        const gps = item.message && item.message.hasOwnProperty('gps')
            ? item.message.gps.data : (item.message ? item.message : null);
        let topic = item.name, color = "primary", ts = gps.ts || item.ts, isGPSTime = Boolean(gps.ts);

        if (item.name === TOPIC_SENSOR) {
            topic = "q-present";
            color = "success";
        } else if (item.name === TOPIC_QLOST) {
            topic = "q-lost";
            color = "danger";
        };

        return {
            topic, color, gps, ts, isGPSTime,
            isPresentGPS: gps && gps.lat && gps.lng ? true : false,
            egName: gps && gps.equipment_group ? gps.equipment_group.equipment_group_name : null
        };
    }, []);

    const mapFilteredMessageList = messageList
        .filter(item => (deviceIds.indexOf(item.deviceId) >= 0 || egIds.indexOf(item.deviceId) >= 0));

    const filteredMessageList = mapFilteredMessageList
        .filter(item =>
            item.isDataShow
            && (deviceIds.indexOf(item.deviceId) >= 0 || egIds.indexOf(item.deviceId) >= 0)
            && ([TOPIC_SENSOR, TOPIC_QLOST].indexOf(item.name) >= 0))
        .filter(item => {
            const gps = item.message && item.message.hasOwnProperty('gps')
                ? item.message.gps.data : (item.message ? item.message : null);
            return gps && gps.equipment_group && searchWord(gps.equipment_group.equipment_group_name, searchText);
        });

    const qPresentList = mapFilteredMessageList.filter(item => item.name === TOPIC_SENSOR);
    const filteredQPresentList = qPresentList.filter(item => item.isDataShow);
    const qLostList = mapFilteredMessageList.filter(item => item.name === TOPIC_QLOST);
    const filteredQLostList = qLostList.filter(item => item.isDataShow);

    return <><Card className={`card-live-console`}>
        <Card.Header>
            <div className="d-flex justify-content-between title-info">
                <Card.Title as="h6">Live Console</Card.Title>
                <div className="card-close"  >
                    <span className="mr-3 clear-log" title="Clear log"
                        onClick={() => dispatch(updateLiveDataShow())}>Clear log</span>
                    <i className="fa fa-times" title="Close" onClick={props.onClose} />
                </div>
            </div>
            <div className="q-present">Q-Present : <span> <Badge variant={"success"}>{`${filteredQPresentList.length}/${qPresentList.length}`}</Badge></span></div>
            <div className="q-lost">Q-Lost : <span> <Badge variant={"danger"}>{`${filteredQLostList.length}/${qLostList.length}`}</Badge></span></div>
        </Card.Header>
        <Card.Body>
            <SubNav.SearchBox
                placeholder="Equipment Group Name"
                value={searchText}
                onChange={e => setSearchText(e.target.value)}
                onClear={() => setSearchText("")}
            />
            {filteredMessageList.map((item, i) => {
                const { topic, color, gps, isPresentGPS, egName, ts, isGPSTime } = getTopic(item);

                return <div key={i} className="body-info">
                    <p>
                        <span className="mr-1 text-500">EG Name :</span>
                        <span>{egName}</span>
                        <span className="pl-1">
                            <Badge pill variant={color}>{topic}</Badge>
                        </span>
                    </p>
                    <p>
                        <span className="mr-1 text-500">{`${isGPSTime ? 'GPS' : 'Current'} Time: `}</span>
                        <span>
                            {moment.utc(ts).tz(timezoneIdentifier).format(DISPLAY_DATETIMESECONDS_FORMAT2)}
                        </span>
                    </p>
                    {isPresentGPS && <p>
                        <span className="mr-1 text-500">Latitude :</span>
                        <span className="mr-2">{gps.lat}</span>
                        <span className="mr-1 text-500">Longitude :</span>
                        <span>{gps.lng}</span>
                    </p>}
                    <div className="log-info mt-1">
                        <Button
                            className="log-info-btn"
                            title="Log Info"
                            onClick={() => handleModal(item)}>Log Info</Button>
                    </div>
                </div>
            })}
        </Card.Body>
    </Card>
        {showModal && logInfo && <LogModal logInfo={logInfo} onClose={onClose} />}
    </>
};

export default (LiveConsoleWindow);